import { useTranslation } from 'react-i18next'
import { ReactSVG } from 'react-svg'
import { useMediaQuery } from 'usehooks-ts'


import { useModalStore } from '@features/modal'
import DeleteAddressModal from '@features/shipping-methods/pickup/DeleteAddressModal'
import { AddressItemType, PickupShop } from '@features/shipping-methods/types'

import useDeliveryModal from '@widgets/modal-delivery/ui/useDeliveryModal'

import { useMyAddressesQuery } from '@shared/generated'
import Button from '@shared/ui/button'

import AddressItem from './Item'

import styles from './styles.module.scss'

export default function PersonalAddresses () {
  const { t: tn } = useTranslation('personal')
  const { t: to } = useTranslation('order')
  const isTablet = useMediaQuery('(max-width: 767px)')
  const { openModal } = useModalStore()
  const { data: { myAddresses = [] } = {}, refetch } = useMyAddressesQuery()
  const { openDeliveryModal } = useDeliveryModal()
  const handleDeleteAddress = (shop: PickupShop | AddressItemType) => {
    openModal(
      'deleteAddress',
      <DeleteAddressModal shop={shop} onSuccess={refetch} />,
      {
        title: to('delete_address'),
      },
    )
  }

  return (
    <div className={styles.root}>
      {myAddresses?.length === 0 ? (
        <div className={styles.empty}>
          <div className={styles.empty__title}>
            <div className={styles.empty__pin}>
              <ReactSVG src="/icons/map-pin.svg" />
            </div>
            <span>{tn('addresses.empty')}</span>
          </div>
          <p>{tn('addresses.savings')}</p>
          <Button
            onClick={() => {
              openDeliveryModal(refetch)
            }}
            size={isTablet ? 'medium' : 'large'}
          >
            {tn('addresses.button')}
          </Button>
        </div>
      ) : (
        <div className={styles.root__addresses}>
          {myAddresses
            ?.filter((item) => item !== null && !item.shop_id)
            .map((item) => (
              <AddressItem
                key={item?.id}
                data={item as AddressItemType}
                onDelete={handleDeleteAddress}
              />
            ))}

          <Button
            onClick={() => {
              openDeliveryModal(refetch)
            }}
            theme="secondary"
            size={isTablet ? 'medium' : 'large'}
          >
            {tn('addresses.button')}
          </Button>
        </div>
      )}
    </div>
  )
}
